import React from 'react';
import { JTableCellStyled } from './jtable-cell.styled';

interface Props {
  children: React.ReactNode;
  isbold?: boolean;
}

const JTableCell = ({ children, isbold = false }: Props) => {
  return <JTableCellStyled isbold={isbold}>{children}</JTableCellStyled>;
};

export default JTableCell;
